/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { bignumberDependencies } from './dependenciesBignumber.generated.js';
import { divideDependencies } from './dependenciesDivide.generated.js';
import { isNegativeDependencies } from './dependenciesIsNegative.generated.js';
import { isPositiveDependencies } from './dependenciesIsPositive.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { mapDependencies } from './dependenciesMap.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { maxDependencies } from './dependenciesMax.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { smallerDependencies } from './dependenciesSmaller.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated.js';
import { createSolveODE } from '../../factoriesAny.js';
export var solveODEDependencies = {
  absDependencies,
  addDependencies,
  bignumberDependencies,
  divideDependencies,
  isNegativeDependencies,
  isPositiveDependencies,
  largerDependencies,
  mapDependencies,
  matrixDependencies,
  maxDependencies,
  multiplyDependencies,
  smallerDependencies,
  subtractDependencies,
  typedDependencies,
  unaryMinusDependencies,
  createSolveODE
};